export default __webpack_public_path__ + "static/logotipo-Oasis-color-eefde701cb6a32c86c41627a2c2f057a.svg";